import React, { useState } from "react";
//import './globals.scss';
import PrimaryButton from "./components/Buttons/PrimaryButton";
import { useNavigate } from "react-router-dom"; // React Router's navigation hook
import { sendEmailVerification } from 'firebase/auth';
import { auth } from "./firebase";
import { showToastError, showToastSuccess } from "./utils/showToasify"; // Assuming you have these utility functions

function ChangeEmail() {
    const [email, setEmail] = useState("");
    /* eslint-disable-next-line no-useless-escape */
    const EMAIL_VALIDATOR = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const navigate = useNavigate(); // React Router's navigate hook

    const sendEmailResetLink = async (email) => {
       // const auth = getAuth(); // Get the Firebase Authentication instance
        const actionCodeSettings = {
            // The URL to redirect to after the user clicks the link. 
            // This URL must be in the authorized domains list in your Firebase project settings.
            url: 'https://verify.peeq.inc/resetEmailLink', // Replace with your actual URL
            handleCodeInApp: true,  // This flag tells Firebase to handle the code in your app
        };

        try {
            await sendEmailVerification(auth.currentUser, actionCodeSettings); // Sends the reset link email
            showToastSuccess("An email with the reset link has been sent to your email!");
            navigate('/checkEmail');
        } catch (error) {
            console.error('Error sending email reset link:', error);
            showToastError("Error sending email reset link. Please try again.");
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email.trim() === "") {
            showToastError("Please fill all the fields");
        } else if (!EMAIL_VALIDATOR.test(email)) {
            showToastError("Please enter a valid email");
        } else {
            sendEmailResetLink(email); // Call the function to send the reset link
        }
    };

    return (
        <div>
            <img
                src="/peeqlogo.svg"
                alt="Peeq Logo"
                className="mx-auto pt-10 cursor-pointer"
                onClick={() => navigate('/accounts/business')}
            />

            <div className="flex justify-center rounded-full bg-[#FFF7E5] m-auto w-[200px] h-[200px] mt-8">
                <img src="/key.svg" alt="Peeq Logo" className="p-[60px]" />
            </div>

            <div className="emailcontent">
                <div className="emailinputs m-auto">
                    <div className="title">Change email</div>
                    <p className="text">We will send your one-time password to the email below</p>
                    <div className="email-container pt-4">
                        <img src="/emailicon.svg" alt="email Logo" className="email-toggle" />
                        <input
                            className="w-full outline-none border-none h-12 rounded-[1rem] pl-10 bg-[#F4F5F5] placeholder:text-[#94979F] font-normal text-[0.90rem] md:text-[1rem] placeholder:text-[0.90rem] md:placeholder:text-[1rem]"
                            type="email"
                            placeholder="Enter Your Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="emailbottom">
                        <p className="text">Email can only be changed once every 30 days</p>
                        <div className="submit-button-container">
                            <PrimaryButton variant="full" text="Next" onClick={handleSubmit} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChangeEmail;
